
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 21 15"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('rect',{attrs:{"id":"a","width":"21","height":"15","rx":"2"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#a"}}),_c('path',{attrs:{"fill":"#0A17A7","mask":"url(#b)","d":"M0 0h21v15H0z"}}),_c('path',{attrs:{"fill":"#FFF","mask":"url(#b)","d":"M0 10h8v6h5v-6h8V5h-8v-6H8v6H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M21.962-1.437L23.08.22 12.288 7.5l10.792 7.28-1.118 1.657L10.5 8.706.696 15.319-.422 13.66 8.712 7.5-2.08.22l1.118-1.657L10.5 6.293l11.462-7.73z","mask":"url(#b)"}}),_c('path',{attrs:{"stroke":"#DB1F35","stroke-linecap":"round","stroke-width":".667","d":"M14.013 5.026L20.5.69m-5.733 9.59l5.733 3.93M6.161 4.506L.5.69m5.97 9.59L.5 14.21","mask":"url(#b)"}}),_c('path',{attrs:{"fill":"#E6273E","mask":"url(#b)","d":"M0 9h9v6h3V9h9V6h-9V0H9v6H0z"}})])])
          )
        }
      }
    